<template>
	<v-row justify="center">
		<template v-if="ui.success">
			<v-col cols="12" md="10">
				<v-card>
					<v-card-text>
						<v-row>
							<v-col
								cols="12"
								class="d-flex flex-column align-center justify-center"
								style="height: 70vh;"
							>
								<div class="d-flex align-center justify-center">
									<h1>
										¡Pedido enviado correctamente!
									</h1>
									<v-icon
										class="success--text ml-1"
										style="font-size: 1.8rem;"
									>
										mdi-checkbox-marked-circle-outline
									</v-icon>
								</div>

								<p class="mt-3">
									Tu pedido fué enviado correctamente. Te
									notificaremos cuando los agentes de ventas
									lo reciban.
								</p>

								<div class="mt-4 d-flex">
									<v-btn color="primary" text>
										ir a mis pedidos
									</v-btn>

									<router-link
										tag="div"
										:to="{ name: 'StoreIndex' }"
									>
										<v-btn color="primary" class="ml-1">
											seguir comprando
										</v-btn>
									</router-link>
								</div>
							</v-col>
						</v-row>
					</v-card-text>
				</v-card>
			</v-col>
		</template>

		<template v-else>
			<v-col cols="12" md="10">
				<!-- <template>
					<v-stepper v-model="ui.step">
						<v-stepper-header>
							<v-stepper-step :complete="ui.step > 1" step="1">
								Metodo de envío
							</v-stepper-step>

							<v-divider></v-divider>

							<v-stepper-step :complete="ui.step > 2" step="2">
								Datos generales
							</v-stepper-step>

							<v-divider></v-divider>

							<v-stepper-step step="3">
								Enviar pedido
							</v-stepper-step>
						</v-stepper-header>

						<v-stepper-items>
							<v-stepper-content step="1">
								<v-card>
									<v-card-text>
										<div style="height: 200px;"></div>
									</v-card-text>
									<v-card-actions class="justify-end">
										<v-btn
											color="primary"
											@click="ui.step = 2"
										>
											Continuar
										</v-btn>
									</v-card-actions>
								</v-card>
							</v-stepper-content>

							<v-stepper-content step="2">
								<v-card>
									<v-card-text>
										<div style="height: 200px;"></div>
									</v-card-text>
									<v-card-actions class="justify-end">
										<v-btn
											color="primary"
											text
											@click="ui.step = 1"
										>
											Retroceder
										</v-btn>
										<v-btn
											color="primary"
											@click="ui.step = 3"
										>
											Continuar
										</v-btn>
									</v-card-actions>
								</v-card>
							</v-stepper-content>

							<v-stepper-content step="3">
								<v-card>
									<v-card-text>
										<div style="height: 200px;"></div>
									</v-card-text>
									<v-card-actions class="justify-end">
										<v-btn
											color="primary"
											text
											@click="ui.step = 2"
										>
											Retroceder
										</v-btn>
										<v-btn
											color="primary"
											@click="ui.step = 1"
										>
											Continuar
										</v-btn>
									</v-card-actions>
								</v-card>
							</v-stepper-content>
						</v-stepper-items>
					</v-stepper>
				</template> -->

				<v-card class="pa-4">
					<v-card-title>
						Realizar pedido
					</v-card-title>

					<v-card-text>
						<v-row>
							<v-col cols="12">
								<v-overflow-btn
									label="Metodo de envío"
									editable
									dense
									clearable
									outlined
									flat
									darck
									background-color="#fff"
									autocomplete="off"
									:items="
										this.shipping_methods.map((item) => {
											return {
												text: item.name,
												value: item.id,
											};
										})
									"
									:disabled="
										$store.state.ui.getingShippingMethods
									"
									:loading="
										$store.state.ui.getingShippingMethods
									"
									v-model="salesorder.shipping_method_id"
									@change="save()"
								></v-overflow-btn>
							</v-col>
						</v-row>
					</v-card-text>
				</v-card>
			</v-col>
		</template>
	</v-row>
</template>

<script>
import { mapState } from "vuex";

export default {
	name: "Checkout",

	data() {
		return {
			salesorder: {
				shipping_method_id: null,
			},

			ui: {
				step: 1,
				success: false,
			},
		};
	},

	created() {
		this.$store.dispatch("getShippingMethods");
	},

	computed: {
		...mapState(["shipping_methods"]),
	},
};
</script>

<style lang="css" scoped></style>
